export default {
      ProductYears: 'سنة الصنع|سنوات الصنع',
      ProductYears_no_body: 'سنة صنع',

};
